// src/components/Footer.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaWhatsapp, FaEnvelope, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

function Footer() {
  return (
    <div
      style={{
        backgroundColor: '#FFD700',
        color: '#fff',
        paddingTop: '40px',
        paddingBottom: '40px',
        fontSize: '0.95rem',
      }}
    >
      <Container>
        <Row className="gy-4">
          {/* Contato */}
          <Col md={4}>
            <h5 className="mb-3 fw-bold text-white">CONTATO</h5>
            <p><FaWhatsapp className="me-2" /> Whatsapp: +55 81 99919-5144</p>
            <p><FaEnvelope className="me-2" /> E-mail: contatoaappd@hotmail.com</p>
            <p><FaClock className="me-2" /> Atendimento: Seg. a Sex., 8h às 18h</p>
          </Col>

          {/* Endereço */}
          <Col md={4}>
            <h5 className="mb-3 fw-bold text-white">ENDEREÇO</h5>
            <p>
              <FaMapMarkerAlt className="me-2" />
              Av. Bernardo Vieira de Melo, 1730 - Piedade, Jaboatão dos Guararapes  - PE<br />
              54410-010
            </p>
          </Col>

          {/* Suporte */}
          {/* <Col
            md={4}
            className="d-flex flex-column justify-content-center align-items-md-end align-items-start"
          >
            <h5 className="mb-3 fw-bold text-white">SUPORTE</h5>
            <Button
              variant="primary"
              style={{
                background: 'linear-gradient(to right, #4b33ff, #8f6eff)',
                border: 'none',
                borderRadius: '50px',
                padding: '10px 25px',
                fontWeight: 'bold',
              }}
            >
              Fale Conosco!
            </Button>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}

export default Footer;
